// extracted by mini-css-extract-plugin
module.exports = {"list":"productSpecifications_list__kodkp","row":"productSpecifications_row__hvses","label":"productSpecifications_label__fIANt"};